import React from 'react';
import css from './group.module.scss';

export function Group(props) {
  return (
    <div {...props} className={css('group', props)} />
  );
}
